import { render } from "./Arenamain.vue?vue&type=template&id=55d5c81d"
import script from "./Arenamain.vue?vue&type=script&lang=js"
export * from "./Arenamain.vue?vue&type=script&lang=js"

import exportComponent from "/home/timobile/gitlab_gamotions/gamotions-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__